import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

const COINS = [["BTC", "Bitcoin"], ["ETH", "Ethereum (ERC20)"], ["LTC", "Litecoin"]];

export const WalletsAdmin = () => {
  const [w, setW] = useState({ BTC: "", ETH: "", LTC: "" });
  useEffect(() => { api.get("/admin/wallets").then((r) => setW((prev) => ({ ...prev, ...(r.data || {}) }))); }, []);
  const save = async (e) => {
    e.preventDefault();
    try { await api.put("/admin/wallets", w); toast.success("Wallets saved"); } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <form onSubmit={save} className="max-w-2xl space-y-4" data-testid="wallets-form">
      <p className="text-sm text-zinc-400">Customers send payments to these addresses. Leave a field empty to hide that coin.</p>
      {COINS.map(([k, label]) => (
        <label key={k} className="block">
          <span className="mb-1 block text-sm text-zinc-300">{label}</span>
          <input data-testid={`wallet-input-${k.toLowerCase()}`} value={w[k]} onChange={(e) => setW({ ...w, [k]: e.target.value })} className="field font-mono text-sm" />
        </label>
      ))}
      <button data-testid="wallets-save-button" className="btn-primary">Save wallets</button>
    </form>
  );
};
